module.exports = "/_next/static/images/8d3b778e96a13e19dfb61a6032e80b9b-purple-man@0.75x.jpg";